import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be51d06a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=be51d06a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be51d06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be51d06a')) {
      api.createRecord('be51d06a', component.options)
    } else {
      api.reload('be51d06a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be51d06a&scoped=true&", function () {
      api.rerender('be51d06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contentCenter/newMall/activityStatistics/index.vue"
export default component.exports